import { makeUID } from "../util/uid";
import { InitToken } from "./collab";
import { EventEmitter } from "./event_emitter";
/**
 * Skeletal implementation of [[Runtime]] that uses
 * a root [[Collab]].
 */
export class AbstractRuntime extends EventEmitter {
    constructor(replicaID) {
        super();
        this.replicaID = replicaID;
        this.isRuntime = true;
        this.idCounter = 0;
        if (replicaID === "") {
            throw new Error('replicaID must not be ""');
        }
    }
    setRootCollab(preRootCollab) {
        const rootCollab = preRootCollab(new InitToken("", this));
        this.rootCollab = rootCollab;
        return rootCollab;
    }
    getReplicaUniqueNumber(count = 1) {
        const ans = this.idCounter;
        this.idCounter += count;
        return ans;
    }
    getUID() {
        return makeUID(this.replicaID, this.getReplicaUniqueNumber());
    }
    getNamePath(descendant) {
        return this.rootCollab.getNamePath(descendant);
    }
    getDescendant(namePath) {
        return this.rootCollab.getDescendant(namePath);
    }
}
//# sourceMappingURL=abstract_runtime.js.map